import Skeleton from "@mui/material/Skeleton";
import { FC } from "react";

const SkeletonUploadImageField: FC = () => (
  <Skeleton
    sx={{
      height: 40,
      borderRadius: "0.5rem",
      transform: "none",
    }}
  />
);

export default SkeletonUploadImageField;
